module.exports = __webpack_public_path__ + "static/img/slowmedicine.369108e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patrocinio/slowmedicine.jpg
// module id = j7iy
// module chunks = 1